import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { FIRM, VALUES } from "../data/content";
import { useConsultation } from "../components/ConsultationContext";
import Reveal from "../components/Reveal";

export default function About() {
  const consult = useConsultation();
  return (
    <div data-testid="about-page">
      <section className="bg-[#0A192F] text-white pt-44 pb-32 relative overflow-hidden">
        <div className="absolute -top-40 -left-40 h-[36rem] w-[36rem] rounded-full bg-[#1B3563]/40 blur-[120px]" aria-hidden />
        <div className="container-x relative">
          <p className="eyebrow text-[#C5A059]">About the Firm</p>
          <h1 className="editorial-display text-[clamp(2.8rem,7.4vw,7.5rem)] mt-10 max-w-5xl">
            A professionally managed practice, <br /><span className="italic text-[#C5A059]">established in 1998.</span>
          </h1>
          <p className="text-white/70 mt-12 max-w-2xl text-lg lg:text-xl leading-[1.7]">
            R K Nitta & Co., is a Chartered Accountancy firm offering professional services in taxation, audit, compliance and advisory to businesses, professionals and individuals.
          </p>
        </div>
      </section>

      {/* Founder */}
      <section className="bg-white">
        <div className="container-x py-28 lg:py-40 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <Reveal className="lg:col-span-4 lg:sticky lg:top-32">
            <div className="max-w-[320px] mx-auto lg:mx-0">
              <div className="relative">
                <div className="absolute -inset-3 border border-[#C5A059]/40 hidden lg:block" aria-hidden />
                <div className="relative aspect-[4/5] w-full bg-[#FBFAF6] overflow-hidden">
                  <img
                    src={FIRM.founder.image}
                    alt={FIRM.founder.name}
                    className="absolute inset-0 w-full h-full object-cover object-top"
                    loading="eager"
                  />
                </div>
              </div>
              <div className="mt-7">
                <p className="font-serif text-xl text-[#0A192F] leading-snug">{FIRM.founder.name}</p>
                <p className="text-xs text-[#475569] mt-2 tracking-wide">{FIRM.founder.credentials}</p>
                {FIRM.founder.membership && <p className="text-xs text-[#475569]">{FIRM.founder.membership}</p>}
              </div>
            </div>
          </Reveal>
          <Reveal className="lg:col-span-8" delay={150}>
            <p className="eyebrow text-[#C5A059]">Founder</p>
            <h2 className="editorial-display text-[#0A192F] text-[clamp(2.4rem,5vw,4.6rem)] mt-8 leading-[1.04]">
              CA. Nitta Ravi Kishore
            </h2>
            <p className="font-serif italic text-[#C5A059]/80 mt-6 text-base lg:text-lg tracking-wide">
              B.Com.,  FCA.,  ACMA.,  DISA (ICAI)
            </p>
            <div className="mt-12 space-y-7 text-[#334155] leading-[1.85] text-[1.05rem] max-w-[68ch]">
              {FIRM.founder.bio.map((p, i) => <p key={i}>{p}</p>)}
            </div>
            <div className="mt-12 flex flex-wrap gap-3">
              {["Chartered Accountant", "Information Systems Auditor", "Speaker", "Educator"].map((t) => (
                <span key={t} className="px-4 py-2 border border-[#0A192F]/15 text-[#0A192F] text-xs tracking-wider uppercase">{t}</span>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* Values */}
      <section className="bg-[#FBFAF6]">
        <div className="container-x py-28 lg:py-36">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-20">
            <Reveal className="lg:col-span-7">
              <p className="eyebrow text-[#C5A059]">Our Approach</p>
              <h2 className="editorial-display text-[#0A192F] text-[clamp(2.4rem,5vw,4.8rem)] mt-8 leading-[1.04]">
                Principles that guide every <br /><span className="italic text-[#C5A059]">professional engagement.</span>
              </h2>
            </Reveal>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#0A192F]/10 border border-[#0A192F]/10">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 90}>
                <div data-testid={`value-${i}`} className="bg-white p-10 lg:p-12 h-full transition-colors hover:bg-[#FBFAF6]">
                  <span className="num-tag">{String(i+1).padStart(2,"0")}</span>
                  <h3 className="font-serif text-3xl text-[#0A192F] mt-12">{v.title}</h3>
                  <p className="text-[#475569] mt-5 leading-relaxed">{v.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white">
        <div className="container-x py-12" aria-hidden />
      </section>
    </div>
  );
}
